module.exports = __webpack_public_path__ + "img/menu-bridge.48fbc49.svg";